"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeDocumentListModal = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
// versions and dates when it starts, newest first
var IPIDVersionDates = [
    { version: "v3", date: new Date("2024-01-01") },
    { version: "v2", date: new Date("1980-01-01") },
    { version: "v1", date: new Date("1970-01-01") },
];
// versions and dates when it starts, newest first
var DOIVersionDates = [
    { version: "v2", date: new Date("2024-09-12") },
    { version: "v1", date: new Date("1970-01-01") },
];
var AnnualHomeDocumentListModal = exports.AnnualHomeDocumentListModal = /** @class */ (function (_super) {
    __extends(AnnualHomeDocumentListModal, _super);
    function AnnualHomeDocumentListModal(props) {
        var _this = _super.call(this, props) || this;
        _this.documents = [];
        _this.filterDocumentsByAddon = function (document, annualHomeFixedAddons) {
            return (!annualHomeFixedAddons ||
                !document.addon ||
                (annualHomeFixedAddons && (annualHomeFixedAddons === null || annualHomeFixedAddons === void 0 ? void 0 : annualHomeFixedAddons[document.addon])));
        };
        _this.documents = [
            {
                title: services_1.HOME_HE_PDF_NAME,
                path: services_1.HOME_HE_PDF_PATH,
                filename: services_1.HOME_HE_PDF_FILENAME,
                size: "",
                addon: "homeEmergency",
            },
            {
                title: services_1.HOME_HLE_PDF_NAME,
                path: services_1.HOME_HLE_PDF_PATH,
                filename: services_1.HOME_HLE_PDF_FILENAME,
                size: "",
                addon: "homeLegalExpenses",
            },
            {
                title: services_1.HOME_PIU_PDF_NAME,
                path: services_1.HOME_PIU_PDF_PATH,
                filename: services_1.HOME_PIU_PDF_FILENAME,
                size: "",
            }
        ];
        return _this;
    }
    AnnualHomeDocumentListModal.prototype.componentDidMount = function () {
        var _this = this;
        var tierDocument = this.getIpidDocument(this.props.coverTier);
        var doiDocument = this.getDoiDocument();
        this.documents.splice(0, 0, tierDocument, doiDocument);
        this.documents.forEach(function (doc) {
            _this.baseRequestService.getDocumentSize(doc.path).subscribe(function (response) {
                doc.size = (0, commonFunctions_1.formatFileSize)(response.xhr.getResponseHeader('content-length'));
                _this.setState({ documents: _this.documents });
            });
        });
        this.setState({ documents: this.documents });
    };
    AnnualHomeDocumentListModal.prototype.render = function () {
        var _this = this;
        if (this.state) {
            var documentsToRender = this.state.documents
                .filter(function (d) { return _this.filterDocumentsByAddon(d, _this.props.annualHomeFixedAddons); })
                .map(function (document, i) { return (React.createElement("li", { key: document.filename + i, className: "media" },
                React.createElement("img", { className: "mr-2 document-icon", alt: "document-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }),
                React.createElement("div", { className: "media-body" }, document.title ?
                    (React.createElement("h5", null,
                        React.createElement("a", { className: "no-underline font-weight-light", href: document.path, download: document.filename, id: _this.trimFileExtension(document.filename), "aria-label": "".concat(document.title) },
                            document.title,
                            ", PDF, ",
                            document.size))) : ""))); });
            return this.props.withTitle ? (React.createElement("div", { id: "policyDocuments", className: "documents-widget mt-0 documents-output-widget" },
                React.createElement("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18" }, "Documents"),
                React.createElement("ul", { className: "list-unstyled documents-section" }, documentsToRender))) : (React.createElement("ul", { className: "list-unstyled documents-section" }, documentsToRender));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualHomeDocumentListModal.prototype.getIpidDocument = function (coverTier) {
        var _this = this;
        var latestVersionForDate = IPIDVersionDates.find(function (vd) { return _this.props.policyDate >= vd.date; });
        var documentVersion = latestVersionForDate ? latestVersionForDate.version : IPIDVersionDates[0].version;
        var coverCamel = coverTier.charAt(0) + coverTier.slice(1).toLowerCase();
        return {
            title: "Allianz ".concat(coverCamel, " Home Insurance Product Information Document"),
            path: "/resources/documents/LV_Allianz_Annual_Home/".concat(documentVersion, "/LV_Allianz_Home_IPID_").concat(coverTier, ".pdf"),
            filename: "Allianz".concat(coverCamel, "HomeInsuranceProductInformationDocument.pdf"),
            size: "",
        };
    };
    AnnualHomeDocumentListModal.prototype.getDoiDocument = function () {
        var _this = this;
        var latestVersionForDate = DOIVersionDates.find(function (vd) { return _this.props.policyDate >= vd.date; });
        var documentVersion = latestVersionForDate ? latestVersionForDate.version : DOIVersionDates[0].version;
        return {
            title: "Allianz Home Document of Insurance",
            path: "/resources/documents/LV_Allianz_Annual_Home/".concat(documentVersion, "/LV_Allianz_Home_DOI.pdf"),
            filename: "AllianzHomeDocumentInsurance.pdf",
            size: "",
        };
    };
    AnnualHomeDocumentListModal.prototype.trimFileExtension = function (filename) {
        return filename.substring(0, filename.lastIndexOf('.'));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.BaseRequestService),
        __metadata("design:type", Object)
    ], AnnualHomeDocumentListModal.prototype, "baseRequestService", void 0);
    return AnnualHomeDocumentListModal;
}(React.Component));
//# sourceMappingURL=AnnualHomeDocumentListModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomeDocumentListModal.js
// module id = 750
// module chunks = 0